
export class StockModel {
    public stockLevelStatus: string;
}